export enum ApplyWizardStepList {
  personalInfo = 'personalInfo',
  phoneConfirm = 'phoneConfirm',
  experience = 'experience',
  miniInterview = 'miniInterview',
  skill = 'skill',
  language = 'language',
  premiumPromo = 'premiumPromo',
  study = 'study',
  videoInterview = 'videoInterview',
}
